/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsassistanthandled2Inputs */

const en_statsassistanthandled2 = /** @type {(inputs: Statsassistanthandled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handled messages`)
};

const de_statsassistanthandled2 = /** @type {(inputs: Statsassistanthandled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigte Nachrichten`)
};

/**
* | output |
* | --- |
* | "Handled messages" |
*
* @param {Statsassistanthandled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsassistanthandled2 = /** @type {((inputs?: Statsassistanthandled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsassistanthandled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsassistanthandled2(inputs)
	return de_statsassistanthandled2(inputs)
});
export { statsassistanthandled2 as "statsAssistantHandled" }